import request from '@/utils/request'

const service = (config) => {
  config.url = '/dms' + config.url
  return request(config)
}

export default service
